import React from 'react';
import classnames from 'classnames';
import moment from 'moment-timezone';
import {Grid} from 'semantic-ui-react';
import {DateTimePicker} from 'react-widgets';
import {bool, func, number} from 'prop-types';
import momentLocalizer from 'react-widgets-moment';
import FieldStatusIcon from 'components/forms/FieldStatusIcon';
import {EmptyFunc} from 'utils/DBUtils';

export default class AutoSaveDateOrderedInput extends React.Component {
  static propTypes = {
    value: number,
    onChange: func,
    disabled: bool,
    isSaving: bool,
    saveError: bool,
    saveSuccess: bool
  };

  static defaultProps = {
    value: null,
    onChange: EmptyFunc
  };

  constructor(props) {
    super(props);
    moment.locale('en');
    momentLocalizer();
  }

  handleChange = value => {
    this.props.onChange(moment(value).valueOf());
  };

  get className() {
    return classnames('date-ordered-input', {'has-value': this.props.value});
  }

  get value() {
    return this.props.value ? moment(this.props.value).toDate() : null;
  }

  render() {
    return (
      <Grid columns={2} className={this.className}>
        <Grid.Row>
          <Grid.Column width={12}>
            <DateTimePicker
              time={false}
              value={this.value}
              onChange={this.handleChange} />
          </Grid.Column>
          <Grid.Column width={4}>
            <FieldStatusIcon
              error={this.props.saveError}
              isSaving={this.props.isSaving}
              saved={this.props.saveSuccess} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
};



// WEBPACK FOOTER //
// ./public/pages/ListWinners/AutoSaveDateOrderedInput.jsx